module.exports={
    "两次输入的密码必须一致": "Kata sandi harus cocok",
    "取消": "Batalkan",
    "如验证出现问题，请点击": "Masalah Verifikasi",
    "如验证出现问题，请联系orcalivecs@asiainnovations.com": "Jika kesalahan verifikasi terjadi, silakan hubungi orcalivecs@asiainnovations.com",
    "如验证出现问题，请联系upcs@asiainnovations.com": "Jika kesalahan verifikasi terjadi, silakan hubungi upcs@asiainnovations.com",
    "密码修改成功": "Kata sandi berhasil diubah!",
    "密码格式错误": "Format yang salah",
    "密码由6-20位由数字和字母组成": "Kata sandi harus berisi huruf dan panjang 6-20 karakter",
    "恭喜您密码重置成功": "Setel ulang sandi berhasil!",
    "恭喜您已成功激活帐户": "Anda telah mengaktifkan akun Anda!",
    "知道了": "OK",
    "确认修改": "Konfirmasikan modifikasi",
    "网络连接有误, 请稍后再试": "Masalah koneksi, coba lagi nanti",
    "联系客服": "Dukungan Pelanggan",
    "请再次输入密码": "Konfirmasi sandi",
    "请返回UpVoice中重新进行邮箱验证": "Kembali ke UpVoice untuk verifikasi email",
    "请返回Up直播中重新进行邮箱验证": "Kembali ke Uplive untuk verifikasi email",
    "请返回虎鲸直播中重新进行邮箱验证": "Kembali ke Orcalive untuk verifikasi email",
    "请重新设定登录密码": "Setel ulang kata sandi",
    "请重新设置密码": "Setel ulang kata sandi",
    "赶快返回UpVoice中与全球潮人互动吧": "Kembali ke UpVoice, dan mari berpesta!",
    "赶快返回Up直播中与全球潮人互动吧！": "Kembali ke Uplive, dan mari berpesta!",
    "赶快返回虎鲸直播中与全球潮人互动吧": "Kembali ke Orcalive, dan mari berpesta!",
    "重置密码失败": "Gagal mengatur ulang kata sandi",
    "验证失败": "Verifikasi gagal",
    "验证成功": "Verifikasi sukses!"
};


// WEBPACK FOOTER //
// ./js/lang/idid.js